<template>
  <div class="container">
    <section>
      <div class="layout">
        <div class="child">
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h2>{{ titleText }}</h2>
              </div>
            </div>
          </div>
          <div class="pure-g">
            <div class="pure-u-1">
              <div>
                <h3>
                  Along with being asked for age and gender, you can ask your respondents an additional question before they begin the study. You can ask up to 16 classification questions and offer up to 8 answers for each (only 2 answer are required.)
                </h3>
              </div>
            </div>
          </div>
          <div>
            <form class="pure-form pure-form-stacked" @submit.prevent="handleSubmit" novalidate>
              <fieldset>
                <div class="pure-g">
                  <div class="pure-u-1">
                    <textarea
                      v-model="formModel.question"
                      rows="5"
                      :ref="textareaRefName"
                    ></textarea>
                  </div>
                </div>
                <div v-for="answer in formModel.answers">
                  <div class="pure-g">
                    <div class="pure-u-1">
                      <div>
                        <input :class="answer.getClassObj()" type="text" v-model="answer.text" />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="!isFirstQuestion">
                  <div class="pdng-1">
                    <div @click="onDeleteThisSegmentQuestionButtonClick">
                      <button
                        type="button"
                        class="pure-button bigmi-wide-button bigmi-red-2-button"
                      >
                        <Fai
                          v-if="isDeleteSegmentButtonLoading"
                          :icon="['far', 'circle-notch']"
                          spin
                        />
                        <span v-else>Delete this Classification Question</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="maxNumberQuestionsNotReached">
                  <div class="pdng-1">
                    <div @click="onAddSegmentQuestionButtonClick">
                      <button
                        type="button"
                        class="pure-button bigmi-wide-button bigmi-red-2-button"
                      >
                        <Fai
                          v-if="isAddSegmentButtonLoading"
                          :icon="['far', 'circle-notch']"
                          spin
                        />
                        <span v-else>Add Classification Question</span>
                      </button>
                    </div>
                  </div>
                </div>

                <button type="submit" class="hidden-submit"></button>
              </fieldset>
              <BigStudyNavigation
                :disable-loading="disableChevronLoading"
                @touched="onTouched"
              ></BigStudyNavigation>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  GET_NEXT_STUDY_STEP_ROUTE,
  GET_PREVIOUS_STUDY_STEP_ROUTE,
  GET_IN_PROGRESS_STUDY_ADDITIONAL_CLASSIFICATION_QUESTION_OBJ,
  GET_IN_PROGRESS_STUDY_NUMBER_OF_ANSWERS,
  PUSH_IN_PROGRESS_STUDY_SEGMENT_QUESTION,
  REPLACE_IN_PROGRESS_STUDY_SEGMENT_QUESTION_AT_INDEX,
  DELETE_IN_PROGRESS_STUDY_SEGMENT_QUESTION_AT_INDEX,
  GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS,
  UPDATE_STUDY,
  R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N,
  GET_IS_IN_PROGRESS_STUDY_UPDATING,
  CSS_CLASS_NAME_INVALID, GET_BACKEND_URL, GET_HTTP_CONFIG,
} from "../../services/constants";
import http from "@/services/axios";

const MAX_QUESTIONS = 16;

const segmentQuestionFactory = (n) => {
  const answers = [];
  for (let i = 0; i < n; i++) {
    answers.push({
      text: "",
    });
  }
  return {
    question: "",
    answers,
    multiSelect: true,
  };
};

export default {
  name: "SegmentQuestion",
  data() {
    return {
      formModel: null,
      clickSourceAddSegmentQuestionButton: false,
      clickSourceDeleteSegmentQuestionButton: false,
      submitTouched: false,
    };
  },
  computed: {
    ...mapGetters([
      GET_NEXT_STUDY_STEP_ROUTE,
      GET_IN_PROGRESS_STUDY_ADDITIONAL_CLASSIFICATION_QUESTION_OBJ,
      GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS,
      GET_IS_IN_PROGRESS_STUDY_UPDATING,
      GET_IN_PROGRESS_STUDY_NUMBER_OF_ANSWERS,
      GET_PREVIOUS_STUDY_STEP_ROUTE,
    ]),
    isQuestionValid() {
      return this.formModel.question.length > 0;
    },
    areAnswersValid() {
      return this.formModel.answers.map((answer, index) => {
        return index > 1 ? true : answer.text.trim().length > 0;
      });
    },
    answersValidUI() {
      return this.areAnswersValid.map((isValid) => {
        return !isValid && this.submitTouched;
      });
    },
    maxNumberQuestionsNotReached() {
      return this.indexFromRoute + 1 < MAX_QUESTIONS;
      // if (
      //   parseInt(this.$store.state.dataModule.inProgressStudy.meta.gridMode.split("x")[0]) === 4
      // ) {
      //   return this.indexFromRoute + 1 < FOUR_X_FOUR_MAX_NUMBER_SEGMENT_QUESTIONS;
      // } else {
      //   return this.indexFromRoute + 1 < SIX_X_SIX_MAX_NUMBER_SEGMENT_QUESTIONS;
      // }
    },
    answersValidationClassObjs() {
      return this.answersValidUI.map((isInvalid) => {
        return {
          [CSS_CLASS_NAME_INVALID]: isInvalid,
        };
      });
    },
    titleText() {
      return `CLASSIFICATION QUESTION ${this.$route.params.n}`;
    },
    isFormModelValid() {
      return (
        this.isQuestionValid &&
        this.areAnswersValid.every((isValid) => {
          return isValid;
        })
      );
    },
    textareaRefName() {
      return "textareaRef";
    },
    questionPlaceholderText() {
      return "How often do you buy this product";
    },
    outgoingFormModel() {
      return {
        question: this.formModel.question,
        answers: this.formModel.answers
          .map((answer) => {
            return answer.text;
          })
          .filter((answer) => {
            return !!answer;
          }),
        multiselect: this.formModel.multiSelect,
      };
    },
    indexFromRoute() {
      return Number(this.$route.params.n) - 1;
    },
    isFirstQuestion() {
      return this.indexFromRoute === 0;
    },
    isLastQuestion() {
      return this.indexFromRoute === this[GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS] - 1;
    },
    currentSegmentQuestion() {
      if (this.indexFromRoute < this[GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS]) {
        return this.$store.state.dataModule.inProgressStudy.segmentQuestions[this.indexFromRoute];
      }
      return null;
    },
    newRoute() {
      return {
        name: R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N,
        params: {
          n: this[GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS] + 1,
        },
      };
    },
    isAddSegmentButtonLoading() {
      return this[GET_IS_IN_PROGRESS_STUDY_UPDATING] && this.clickSourceAddSegmentQuestionButton;
    },
    isDeleteSegmentButtonLoading() {
      return this[GET_IS_IN_PROGRESS_STUDY_UPDATING] && this.clickSourceDeleteSegmentQuestionButton;
    },
    disableChevronLoading() {
      return (
        this.clickSourceAddSegmentQuestionButton || this.clickSourceDeleteSegmentQuestionButton
      );
    },
  },
  watch: {
    $route() {
      this.createdOrRouteChange();
    },
  },
  methods: {
    handleSubmit() {
      if (this.isFormModelValid || this.clickSourceDeleteSegmentQuestionButton) {
        if (this.clickSourceDeleteSegmentQuestionButton) {
          this.$store.commit(DELETE_IN_PROGRESS_STUDY_SEGMENT_QUESTION_AT_INDEX, {
            index: this.indexFromRoute,
          });
        } else {
          this.$store.commit(REPLACE_IN_PROGRESS_STUDY_SEGMENT_QUESTION_AT_INDEX, {
            index: this.indexFromRoute,
            segmentQuestion: this.outgoingFormModel,
          });
        }
        this.$store.dispatch(UPDATE_STUDY).then(() => {
          if (this.clickSourceAddSegmentQuestionButton) {
            if (this.isFormModelValid) {
              // should not be && this.isFormModelValid because then it will go to `else`
              this.$router.push(this.newRoute);
            }
          } else if (this.clickSourceDeleteSegmentQuestionButton) {
            this.$router.push(this[GET_PREVIOUS_STUDY_STEP_ROUTE]);
          } else {
            this.$router.push(this[GET_NEXT_STUDY_STEP_ROUTE]);
          }
        });
      }
    },
    sendIdeabook() {
      const studyId = this.$store.state.dataModule.inProgressStudy.meta.id
      http.post(this.$store.getters[GET_BACKEND_URL](`results/ideabook/${studyId}`), null, this.$store.getters[GET_HTTP_CONFIG]).then(response => {
      }).catch(err => {
        console.error(err)
      })
    },
    onAddSegmentQuestionButtonClick() {
      this.clickSourceAddSegmentQuestionButton = true;
      this.handleSubmit();
    },
    onDeleteThisSegmentQuestionButtonClick() {
      this.clickSourceDeleteSegmentQuestionButton = true;
      this.handleSubmit();
    },
    resetFormModel() {
      const self = this;
      // const numOfAnswers = this[GET_IN_PROGRESS_STUDY_NUMBER_OF_ANSWERS] === 4 ? 4 : 7;
      const numOfAnswers = 8;
      const formModel = segmentQuestionFactory(numOfAnswers);
      // this.formModel = segmentQuestionFactory(numOfAnswers)
      if (this.currentSegmentQuestion) {
        formModel.question = this.currentSegmentQuestion.question;
        formModel.answers = formModel.answers.map((answer, i) => {
          const answerOfCurrentSegmentQuestion = this.currentSegmentQuestion.answers[i];
          let answerText = "";
          if (answerOfCurrentSegmentQuestion) {
            answerText = answerOfCurrentSegmentQuestion;
          }
          return {
            text: answerText,
          };
        });
        formModel.multiSelect = this.currentSegmentQuestion.multiselect;
      }
      formModel.answers.map((answer, i) => {
        answer.getClassObj = () => {
          return self.answersValidationClassObjs[i];
        };
      });
      this.formModel = formModel;
      this.submitTouched = false;
    },
    syncSegmentQuestions() {
      if (!this.currentSegmentQuestion) {
        this.$store.commit(PUSH_IN_PROGRESS_STUDY_SEGMENT_QUESTION, this.outgoingFormModel);
      }
    },
    createdOrRouteChange() {
      this.resetFormModel();
      this.clickSourceAddSegmentQuestionButton = false;
      this.clickSourceDeleteSegmentQuestionButton = false;
      this.syncSegmentQuestions();
    },
    focusTextArea() {
      //$nextTick only needed for Chrome, firefox works without it
      // this.$nextTick(() => {
      //   this.$refs[this.textareaRefName].focus()
      // })
    },
    onTouched() {
      this.submitTouched = true;
    },
  },
  created() {
    this.createdOrRouteChange();
    this.sendIdeabook();
  },
  mounted() {
    this.focusTextArea();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/main";

.container {
  height: 100%;
}

section {
  height: 100%;
}

.layout {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
}

.child {
  width: 100%;
  max-width: 500px;
  margin: 1em;
}

h2 {
  text-align: center;
  color: $red-2;
}

h3 {
  color: $cyan-blue-3;
}

.pure-form input[type="text"],
.pure-form textarea {
  box-shadow: none;
  width: 100%;
  color: $cyan-blue-3;
  border-color: $cyan-blue-3;

  &:focus {
    border-color: $cyan-blue-1;
  }

  &:placeholder-shown {
    color: $gray-3;
  }

  &:-ms-input-placeholder {
    color: $gray-3;
  }

  &.invalid {
    border-color: $red-2;
  }
}

.question-title {
  font-size: 0.83em;
  font-weight: bold;
  color: $cyan-blue-3;
}

::placeholder {
  color: $gray-3;
  opacity: 1;
}
</style>
